export const getTransformTranslateXY = (snappedPreview,
  draggingAssetWidth, x, y, isMultipleDrag) => {
  if (isMultipleDrag) return { x, y }

  if (snappedPreview && snappedPreview.width >= draggingAssetWidth) {
    return { x: snappedPreview.x, y: snappedPreview.y + 2 }
  }
  return { x, y: y + 2 }
}
